import { FractalSDKError, FractalSDKListItemUnknownError } from "../../core/error/index.js";
import { useSignTransaction } from "./use-sign-transaction.js";
import { useGenerateListTransactionMutation } from "../../queries/items.js";
import { useCallback } from 'react';
export const useListItem = () => {
    const { mutateAsync: generateListTransaction } = useGenerateListTransactionMutation();
    const { signTransaction } = useSignTransaction();
    const listItem = useCallback(async ({ price, quantity = 1, tokenAddress, }) => {
        try {
            const { transaction } = await generateListTransaction({
                price,
                quantity,
                tokenId: tokenAddress,
            });
            const { signature } = await signTransaction(transaction);
            return { signature };
        }
        catch (err) {
            if (err instanceof FractalSDKError) {
                throw err;
            }
            throw new FractalSDKListItemUnknownError(`An unknown error occured while attempting to buy ${tokenAddress}. ` +
                `err = ${err}`);
        }
    }, [generateListTransaction, signTransaction]);
    return { listItem };
};
//# sourceMappingURL=use-list-item.js.map